module.exports = __webpack_public_path__ + "static/media/aiml.8107de13.png";